import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { DealerService } from '../shared/services/dealer.service';

@Injectable({
  providedIn: 'root',
})
export class KeyGuard implements CanActivate {
  constructor(private router: Router, private dealerService: DealerService) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const routingNum = route.paramMap.get('routingNum');
    const admin = route.queryParamMap.get('admin');

    if (await this.isValid(routingNum, admin)) {
      if (routingNum != this.dealerService.getRoutingNum()) {
        await this.dealerService.updateRoutingNum(routingNum);
      }
      return true;
    } else {
      if (routingNum != this.dealerService.getRoutingNum()) {
        await this.dealerService.updateRoutingNum(routingNum);
      }
      this.router.navigate(['/fauxbox/', routingNum]);
      return false;
    }
  }

  async isValid(fauxboxKey, admin?: string): Promise<boolean> {
    if (!(this.dealerService.getAccess() || this.dealerService.getAdmin())) {
      await this.dealerService.setAccess(fauxboxKey, admin);
    }
    return this.dealerService.getAccess();
  }
}
